import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSnackbar } from "notistack";
import { FormControlLabel, Checkbox } from "@material-ui/core";

import ButtonLoading from "../../Components/LoadingButton";

import { aceitarContrato, getTermoUso } from "../../Store/Actions/API/contratoActions";
import { logout } from "../../Store/Actions/API/authActions";
import logo from "../../Assets/logotipo.png";
import "./styles.scss";

export default function Contrato(props) {

  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const [aceito, setAceito] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [urlTermo, setUrlTermo] = useState(null);

  useEffect(() => {
    if (!props.fetched) {
      getContrato();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  console.log("TESTE INFRA!")

  const getContrato = async () => {
    setIsFetching(true);
    try {
      const url = await getTermoUso();
      setUrlTermo(url);
      setIsFetching(false);
    } catch (e) {
      console.error(e);
    }
  };

  const handleContract = async () => {
    setIsFetching(true);
    const { status, message } = await aceitarContrato();

    enqueueSnackbar(message, { variant: status ? "success" : "error" });

    if (status) {
      window.location.href = window.location.href.replace("contrato", "");
      redirectTo("/home");
    }
    setIsFetching(false);
  };

  const redirectTo = (path) => {
    history.push(path, true);
  };

  return (
    <div className="contract container">
      <div className="contract__logo">
        <img
          src={logo}
          alt="Calculador de Exclusão do ICMS da base do PIS COFINS"
        />
      </div>

      <div className="contract__wrapper">
        {urlTermo !== null ? (
          <iframe title="Termo de Uso" src={urlTermo + "#view=fitH"} />
        ) : null}
      </div>

      <div className="contract__footer">
        <FormControlLabel
          control={<Checkbox onChange={() => setAceito(!aceito)} />}
          label="Eu li e concordo com o contrato de uso"
        />

        <div>
          <ButtonLoading
            id="button_aceitar_contrato"
            className="btn"
            variant="contained"
            color="secondary"
            disabled={!aceito}
            loading={isFetching}
            onClick={handleContract}
          >
            Aceito
          </ButtonLoading>
          <ButtonLoading
            id="button_declinar_contrato"
            className="btn btn--danger"
            variant="contained"
            loading={isFetching}
            onClick={logout}
          >
            Não aceito
          </ButtonLoading>
        </div>
      </div>
    </div>
  );
}
